import { Route, Switch } from 'react-router-dom';
import React from 'react';
import { DomainSearchGateModule } from '../../module/domainSearchGate.module';
import { BngResultsPage } from './ResultsPage';
export let BngResultsGatePath = /*#__PURE__*/function (BngResultsGatePath) {
  BngResultsGatePath["BNG_RESULTS"] = "/";
  return BngResultsGatePath;
}({});
export const BngResultsGatePages = _ref => {
  let {
    handlers,
    externalViewer,
    showCartHeader
  } = _ref;
  return /*#__PURE__*/React.createElement(DomainSearchGateModule.SDK.Components.ModalsProvider, null, /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
    path: BngResultsGatePath.BNG_RESULTS,
    render: () => /*#__PURE__*/React.createElement(BngResultsPage, {
      handlers: handlers,
      externalViewer: externalViewer,
      showCartHeader: showCartHeader
    })
  })));
};
//# sourceMappingURL=BngResultsGatePages.js.map